import type { AppDispatch } from 'slices'
import * as db from 'store/db'
import { seedProductDetailsFromList } from 'services/productDetailCache'
import { checkConnectivity } from 'utils/connectivityCheck'

/** أنواع fulfilled المطابقة لـ CACHE_THUNKS في offlineMiddleware — لملء Redux من الكاش عند عدم الاتصال. */
const CACHE_TO_FULFILLED: { cacheKey: db.CacheKey; fulfilledType: string }[] = [
 { cacheKey: 'categories', fulfilledType: 'categories/fetchCategories/fulfilled' },
 { cacheKey: 'products', fulfilledType: 'products/fetchProducts/fulfilled' },
 { cacheKey: 'customers', fulfilledType: 'customers/fetchCustomers/fulfilled' },
 { cacheKey: 'suppliers', fulfilledType: 'suppliers/fetchSuppliers/fulfilled' },
 { cacheKey: 'purchases', fulfilledType: 'purchases/fetchPurchases/fulfilled' },
 { cacheKey: 'expenses', fulfilledType: 'expenses/fetchExpenses/fulfilled' },
 { cacheKey: 'deliveries', fulfilledType: 'deliveries/fetchDeliveries/fulfilled' },
 { cacheKey: 'deliveryTrackingToday', fulfilledType: 'deliveries/fetchToday/fulfilled' },
 { cacheKey: 'activeDrivers', fulfilledType: 'deliveries/fetchDrivers/fulfilled' },
 { cacheKey: 'deliveryZones', fulfilledType: 'deliveryZones/fetchDeliveryZones/fulfilled' },
]

/**
 * يملأ الـ store من localforage عندما يكون المتصفح أوفلاين (مثلاً بعد refresh).
 * لا يُستدعى عند الاتصال لتجنب إظهار بيانات قديمة قبل جلب الطازج.
 *
 * مصفوفة تحقق يدوي مقترحة بعد التغييرات:
 * - POS: فاتورة أوفلاين → طلب معلق → عند الاتصال يُدفع عبر pushPending دون فتح POS
 * - منتجات/عملاء: إنشاء أوفلاين → طابور Redux → replayQueue
 * - توصيل: تعيين سائق / تحديث حالة من الطابور يضرب الـ API الصحيح
 * - مصروفات: إنشاء/إلغاء/تعديل (بدون FormData للإنشاء) في الطابور
 * - إعادة تحميل الصفحة أوفلاين: قوائم من الكاش بعد هذا الاستدعاء
 */
export async function hydrateOfflineCaches(dispatch: AppDispatch): Promise<void> {
 if (await checkConnectivity()) return

 for (const { cacheKey, fulfilledType } of CACHE_TO_FULFILLED) {
 try {
 const cached = await db.getCache(cacheKey)
 if (cached?.data == null) continue
 dispatch({
 type: fulfilledType,
 payload: cached.data,
 meta: { requestId: 'offline-cache-hydrate', requestStatus: 'fulfilled' },
 } as any)
 if (cacheKey === 'products') {
 const payload = cached.data as { data?: unknown[] }
 const list = Array.isArray(payload?.data) ? payload.data : []
 seedProductDetailsFromList(list)
 }
 } catch {
 /* ignore per-slice hydrate errors */
 }
 }
}
